import i18n from "i18next";
import React, { useState, useEffect } from "react";
import { fetchWrapper } from "../../../helpers/fetchwrapper";
import { baseUrl } from "../../../helpers/constants";

// Fluent UI Imports
import { AccountDataProtectionDto } from "../../../Models/AccountDataProtection";
import { Field, Switch, Text } from "@fluentui/react-components";

interface IDataProtectionProps {}

function DataProtection(props: IDataProtectionProps) {
  const [dataProtection, setDataProtection] =
    useState<AccountDataProtectionDto>({
      dataSecAllowFindByEmailDomain: true,
      dataSecAllowGetUserProductMigration: true,
      dataSecAutoShareObjects: false,
      dataSecInitialSet: false,
    });

  const [dataLoaded, setDataLoaded] = useState(false);

  const handleDataProtectionValuesChange = (name: string, val: any) => {
    setDataProtection((prevState) => ({
      ...prevState,
      [name]: val,
    }));
  };

  const getDataProtection = () => {
    fetchWrapper
      .getWithAuth(`${baseUrl}/api/account/GetDataProtectionSettings`)
      .then((result: AccountDataProtectionDto) => {
        if (result.dataSecInitialSet == false) {
          setDataProtection({
            dataSecAllowFindByEmailDomain: true,
            dataSecAllowGetUserProductMigration: true,
            dataSecAutoShareObjects: false,
            dataSecInitialSet: true,
          });
          setDataLoaded(true);
        } else {
          setDataProtection(result);
          setDataLoaded(true);
        }
      })
      .catch((error) => {});
  };

  const updateDataProtection = () => {
    fetchWrapper
      .postWithAuth(
        `${baseUrl}/api/account/UpdateDataProtectionSettings`,
        dataProtection,
      )
      .then((result) => {})
      .catch((error) => {});
  };

  useEffect(() => {
    if (dataLoaded) {
      updateDataProtection();
    }
  }, [
    dataLoaded,
    dataProtection.dataSecAllowFindByEmailDomain,
    dataProtection.dataSecAllowGetUserProductMigration,
    dataProtection.dataSecAutoShareObjects,
  ]);

  useEffect(() => {
    getDataProtection();
  }, []);

  return (
    <div style={{ marginTop: "10px" }}>
      <Text>{i18n.t<string>("dataProtectionText")}</Text>

      <Field
        style={{ marginTop: "20px" }}
        label={
          <div style={{ display: "flex", flexDirection: "column" }}>
            <Text style={{ fontWeight: "700" }}>
              {i18n.t<string>("dataSecAllowFindByEmailDomain")}
            </Text>
            <Text style={{ fontSize: "13px" }}>
              ({i18n.t<string>("dataSecAllowFindByEmailDomainDesc")})
            </Text>
          </div>
        }
      >
        <Switch
          label={
            dataProtection.dataSecAllowFindByEmailDomain
              ? i18n.t<string>("on")
              : i18n.t<string>("off")
          }
          checked={dataProtection.dataSecAllowFindByEmailDomain}
          onChange={(ev, val) => {
            handleDataProtectionValuesChange(
              "dataSecAllowFindByEmailDomain",
              val.checked,
            );
          }}
        />
      </Field>

      <Field
        style={{ marginTop: "20px", fontWeight: "700" }}
        label={i18n.t<string>("dataSecAllowGetUserProductMigration")}
      >
        <Switch
          onChange={(ev, val) => {
            handleDataProtectionValuesChange(
              "dataSecAllowGetUserProductMigration",
              val.checked,
            );
          }}
          checked={dataProtection.dataSecAllowGetUserProductMigration}
          label={
            dataProtection.dataSecAllowGetUserProductMigration
              ? i18n.t<string>("on")
              : i18n.t<string>("off")
          }
        />
      </Field>
      <Field
        style={{ marginTop: "25px", fontWeight: "700" }}
        label={i18n.t<string>("dataSecAutoShareObjects")}
      >
        <Switch
          /*  */
          onChange={(ev, val) => {
            handleDataProtectionValuesChange(
              "dataSecAutoShareObjects",
              val.checked,
            );
          }}
          checked={dataProtection.dataSecAutoShareObjects}
          label={
            dataProtection.dataSecAutoShareObjects
              ? i18n.t<string>("on")
              : i18n.t<string>("off")
          }
        ></Switch>
      </Field>
    </div>
  );
}

export default DataProtection;
